import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { getOrdinal, isNotUnrankedLabel } from 'common/utils/helpers';
import EmptyResults from '../EmptyResults';
import VerticalPercentageStackedBarChart from '../VerticalPercentageStackedBarChart';
import HorizontalPercentageStackedBarChart from '../HorizontalPercentageStackedBarChart';
import OrderedResults from '../OrderedResults';
import { ChartType } from '../../enum';
import Tooltip from './Tooltip';

function OrderedQuestionResults(props) {
  const { question, hasResponses } = props;
  const { data, showDataTable } = question;
  const { datasets } = data;
  const chartRef = useRef(null);
  const isEmpty = datasets.length === 0;
  const rankings = datasets?.[0]?.percentages
    ? Object.keys(datasets?.[0]?.percentages)
        .map((label) => getOrdinal(label))
        .filter(isNotUnrankedLabel)
    : [];

  function renderChart() {
    const chartDatasets = datasets.map((dataset) => {
      const percentages = Object.values(dataset.percentages);
      const counts = Object.values(dataset.counts);

      percentages.push(percentages.shift());
      counts.push(counts.shift());

      return {
        label: dataset.label,
        data: percentages,
        counts,
        image: dataset.image,
      };
    });

    switch (question.chartType) {
      case ChartType.VERTICAL_BAR:
        return (
          <VerticalPercentageStackedBarChart
            labels={rankings}
            datasets={chartDatasets}
            Tooltip={Tooltip}
          />
        );
      case ChartType.HORIZONTAL_BAR:
        return (
          <HorizontalPercentageStackedBarChart
            labels={rankings}
            datasets={chartDatasets}
            Tooltip={Tooltip}
          />
        );
      default:
        return null;
    }
  }

  if (isEmpty) return <EmptyResults hasResponses={hasResponses} />;

  return (
    <div className="engage-results-engagement-screen__chart-content">
      <div className="engage-results-engagement-screen__chart-content__chart" ref={chartRef}>
        {renderChart()}
      </div>
      <div style={{ overflowX: 'auto', width: '100%' }}>
        {showDataTable && <OrderedResults data={data} />}
      </div>
    </div>
  );
}

OrderedQuestionResults.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    chartType: PropTypes.string.isRequired,
    showDataTable: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      labels: PropTypes.arrayOf(PropTypes.string).isRequired,
      datasets: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          counts: PropTypes.arrayOf(PropTypes.number).isRequired,
          percentages: PropTypes.arrayOf(PropTypes.number).isRequired,
          image: PropTypes.string,
        })
      ).isRequired,
    }).isRequired,
  }).isRequired,
  hasResponses: PropTypes.bool.isRequired,
};

export default OrderedQuestionResults;
